import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import RegisteredJobPage from '@/features/jobs/registered-job-page';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/$jobId_/processo')({
  component: () => (
    <HomeGate>
      <RegisteredJobPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
